import { Directive, inject, OnDestroy, OnInit, signal, ViewChild, WritableSignal } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { SnackBarService } from "../snack-bar/services/snack-bar.service";
import { TranslateService } from "@ngx-translate/core";
import { GridComponent } from "../grid/components/grid.component";
import { ConfirmationDialogComponent } from "../confirmation-dialog/confirmation-dialog.component";
import { Subscription } from "rxjs";
import { InfoDialogComponent } from "../info-dialog/info-dialog.component";
import { FormBuilder } from "@angular/forms";
import { DialogComponent } from "../dialog/components/dialog.component";

@Directive()
export abstract class GridBase implements OnInit, OnDestroy {

    @ViewChild(GridComponent) grid!: GridComponent;

    @ViewChild(ConfirmationDialogComponent) confirmationDialog!: ConfirmationDialogComponent;

    @ViewChild(InfoDialogComponent) infoDialog!: InfoDialogComponent;

    @ViewChild(DialogComponent) dialog!: DialogComponent;
    
    /** Organizer flag */
    protected isOrganizer: WritableSignal<boolean> = signal(false);

    /** Activated Route reference */
    protected route = inject(ActivatedRoute);

    /** Router reference */
    protected router = inject(Router);

    protected snackBar: SnackBarService = inject(SnackBarService);

    protected translate: TranslateService = inject(TranslateService);

    protected builder = inject(FormBuilder);

    protected sub = new Subscription();

    /** Display reports flag */
    protected display: WritableSignal<boolean> = signal(false);

    ngOnInit(): void {
        /** obtains organizer info from resolver */
        this.route.data.subscribe((data) => {
            this.isOrganizer.set(data?.isOrganizer);
        });
    }

    ngOnDestroy(): void {
        /** unsubscribes from observables */
        this.sub.unsubscribe();
    }

    /**
     * Exports the grid data to excel file
     */
    protected print(): void {
        this.grid?.exportExcel();
    }

    /**
     * Reloads the grid after changes
     */
    protected reload(): void {
        this.grid?.reload();
    }
}